import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function findAllCustomEntitysByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCustomEntitysByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllCustomGroupByEntity(entityId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllCustomFieldGroupByCompanyAndEntity/${entityId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCustomFieldsByGroupAndEntity(entityId, customFieldGroupId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCustomFieldsByGroupAndEntity/${entityId}/${customFieldGroupId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createCustomEntity(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCustomEntity`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCustomEntity(customEntityId, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCustomEntity/${customEntityId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteCustomEntity(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCustomEntity/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createCustomFieldGroup(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCustomFieldGroup`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCustomFieldGroup(customFieldGroupId, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCustomFieldGroup/${customFieldGroupId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteCustomFieldGroup(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCustomFieldGroup/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteCustomField(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCustomField/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createCustomField(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCustomField`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCustomFields(payload, fieldId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCustomFields/${fieldId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCustomFieldGroupSortorder(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCustomFieldGroupSortorder`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCustomFieldSortorder(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCustomFieldSortorder`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCustomDropdownsByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCustomDropdownsByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteCustomDropdown(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCustomDropdown/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createCustomDropdown(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCustomDropdown`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateCustomDropdown(payload, fieldId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCustomDropdown/${fieldId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllCustomOptionsByDropdown(entityId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCustomOptionsByDropdown/${entityId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findCustomDropdownById(entityId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCustomDropdownById/${entityId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllCustomFieldByCompanyAndEntity(entityId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllCustomFieldByCompanyAndEntity/${entityId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    updateCustomEntity,
    createCustomEntity,
    findAllCustomEntitysByCompany,
    getAllCustomGroupByEntity,
    findAllCustomFieldsByGroupAndEntity,
    deleteCustomEntity,
    deleteCustomFieldGroup,
    updateCustomFieldGroup,
    createCustomFieldGroup,
    createCustomField,
    updateCustomFields,
    deleteCustomField,
    updateCustomFieldSortorder,
    updateCustomFieldGroupSortorder,
    findAllCustomDropdownsByCompany,
    deleteCustomDropdown,
    updateCustomDropdown,
    createCustomDropdown,
    findAllCustomOptionsByDropdown,
    findCustomDropdownById,
    getAllCustomFieldByCompanyAndEntity,
}